var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTennisBallWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 492.308 492.308",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M246.154,0C110.423,0,0,110.423,0,246.154s110.423,246.154,246.154,246.154s246.154-110.423,246.154-246.154 S381.885,0,246.154,0z M246.154,19.692c56.12,0,107.495,20.564,147.101,54.492c-41.007,35.158-92.732,54.609-147.101,54.609 c-54.356,0-106.085-19.453-147.1-54.611C138.659,40.255,190.035,19.692,246.154,19.692z M246.154,472.615 c-56.118,0-107.493-20.563-147.099-54.49c41.007-35.162,92.731-54.616,147.099-54.616c54.359,0,106.084,19.453,147.104,54.612 C353.651,452.051,302.275,472.615,246.154,472.615z M407.734,404.615c-44.85-39.136-101.749-60.798-161.58-60.798 c-59.831,0-116.73,21.665-161.575,60.804c-40.097-40.876-64.887-96.821-64.887-158.468c0-61.646,24.789-117.59,64.886-158.466 c44.852,39.135,101.748,60.798,161.576,60.798c59.831,0,116.739-21.665,161.577-60.797c40.096,40.876,64.885,96.82,64.885,158.465 C472.615,307.798,447.828,363.739,407.734,404.615z",
    stroke: "white",
    strokeWidth: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennisBallWhite);
export default __webpack_public_path__ + "static/media/tennis-ball-white.2f6ab94b8440c1d722cb25e4d9134290.svg";
export { ForwardRef as ReactComponent };